import React from 'react'

import ItemCard from 'screens/listingDetail/components/Faq/components/ItemCard'

import classes from './AlternativesList.module.scss'

const AlternativesList = ({ alternatives, eventProps }) => (
  <div className={classes.container}>
    {alternatives.map((alternative, index) => (
      <ItemCard
        key={`overview-alternatives-${alternative.id}`}
        listing={alternative}
        className={classes.alternative}
        eventProps={eventProps}
        listingPosition={index}
      />
    ))}
  </div>
)

export default AlternativesList
